(() => {
  const lifecycle = window.StepaheadUiLifecycle;
  if (!lifecycle?.registerAlpineData) return;

  lifecycle.registerAlpineData('homeBrandDialog', () => ({
    brandOpen: false,
    brandQuery: '',
    brandReturnFocusEl: null,
    normalizeBrand(value) {
      return String(value).normalize('NFKC').toLowerCase();
    },
    brandMatches(value) {
      const query = this.normalizeBrand(this.brandQuery.trim());
      return !query || this.normalizeBrand(value).includes(query);
    },
    brandHasResults() {
      const items = this.$refs.brandList?.querySelectorAll('[data-brand-item]') ?? [];
      return [...items].some((item) => this.brandMatches(item.dataset.brandName));
    },
    openBrandDialog(event) {
      this.brandReturnFocusEl = event.currentTarget instanceof HTMLElement
        ? event.currentTarget
        : document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
      this.brandQuery = '';
      this.brandOpen = true;
      this.$nextTick(() => this.$refs.brandSearch?.focus({ preventScroll: true }));
    },
    closeBrandDialog(returnFocus = true) {
      if (!this.brandOpen) return;
      const returnFocusEl = this.brandReturnFocusEl;
      this.brandOpen = false;
      this.brandQuery = '';
      this.brandReturnFocusEl = null;
      if (returnFocus) {
        this.$nextTick(() => {
          if (returnFocusEl?.isConnected !== false) returnFocusEl?.focus({ preventScroll: true });
        });
      }
    },
    destroy() {
      this.brandOpen = false;
      this.brandQuery = '';
      this.brandReturnFocusEl = null;
    },
  }));
})();
